const searchUrlParams = new URLSearchParams(window.location.search);
const ringVariant = searchUrlParams.get("ring_variant");
const ringHandle = searchUrlParams.get('ring_handle');
const SHAPE_ICONS = {
    'Round': '/cdn/shop/files/round.png?v=1738639927',
    'Oval': '/cdn/shop/files/oval_72662a6b-6db3-4afc-b792-33191f1ab4d1.png?v=1738640891',
    'Emerald': '/cdn/shop/files/emerald_4fb803e6-2a10-4c36-88cd-326b78ccb699.png?v=1738641250',
    'Cushion': '/cdn/shop/files/cushion_ad4a3bae-0b30-481b-b399-dc767e621289.png?v=1738641628',
    'Pear': '/cdn/shop/files/pear_c26d36a1-1fcc-457f-9da5-7415e335a6e2.png?v=1738640523',
    'Radiant': '/cdn/shop/files/radiant_ffc60bb7-7e6a-4529-987e-8b05af75738c.png?v=1738641384',
    'Princess': '/cdn/shop/files/princess_554705e7-8148-4120-86a4-e65650557bac.png?v=1738640772',
    'Marquise': '/cdn/shop/files/marquise_05a6c2d6-2f71-4bf2-ad92-d8d24b744858.png?v=1738640304',
    'Asscher': '/cdn/shop/files/asscher_f6729919-3875-4033-888b-a4e62a95dcd2.png?v=1738641738',
    'Heart': '/cdn/shop/files/heart_311517be-7ca6-4ff0-bd51-2accba6b005d.png?v=1738640644'
};
async function fetchDiamondData(page = 1, filters = {}) {
    try {
        const pageSize = 12;
        
        // 构建请求参数
        const params = new URLSearchParams();
        params.append('page', page);
        params.append('page_size', pageSize);
        
        // 添加基础筛选条件
        params.append('min_price', filters.min_price || 10);
        params.append('max_price', filters.max_price || 3000);
        params.append('min_carat', filters.min_carat || 0.25);
        params.append('max_carat', filters.max_carat || 10);
        
        // 添加形状
        if (filters.shapes && filters.shapes.length > 0) {
            params.append('shapes', filters.shapes.join(','));
        }
        
        // 添加切工
        if (filters.cuts && filters.cuts.length > 0) {
            params.append('cuts', filters.cuts.join(','));
        }
        
        // 添加颜色
        if (filters.colors && filters.colors.length > 0) {
            params.append('colors', filters.colors.join(','));
        }
        
        // 添加净度
        if (filters.clarities && filters.clarities.length > 0) {
          
            params.append('clarities', filters.clarities.join(','));
           // console.log('发送的净度值:', filters.clarities);
        }
        if (filters.order_by) {
            params.append('order_by', filters.order_by);
           // console.log('添加排序字段:', filters.order_by);
        }
        if (filters.order_method) {
            params.append('order_method', filters.order_method);
           // console.log('添加排序方向:', filters.order_method);
        }
        if(ringVariant){
          params.append('settings_variant_id',ringVariant);
        }
        
       // console.log('API Request URL:', `https://apius.gona.net/api/search?${params}`);
        
        const response = await fetch(`${main_api_url}/api/search?${params}`);
        const result = await response.json();
        
        if (result.code === 1) {
            window.diamondData = result.data.data;
            renderDiamondTable(window.diamondData);
            renderDiamondGallery(window.diamondData);
            updateTotalCount(result.data.total);
            window.currentPage = page;
            window.totalPages = Math.ceil(result.data.total / pageSize);
            updatePagination();
        }
    } catch (error) {
        console.error('API请求失败:', error);
    }
}

// 修改分页UI更新函数
function updatePagination() {
    const paginationContainer = document.getElementById('pagination');
    if (!paginationContainer) return;
    
    let paginationHtml = '<nav class="collection__pagination pagination" role="navigation" aria-label="Pagination navigation">';
    
    // 上一页按钮
    if (window.currentPage === 1) {
        paginationHtml += `
            <span class="pagination__item pagination__item--disabled">
                <span class="animated-arrow animated-arrow--reverse"></span>
            </span>
        `;
    } else {
        paginationHtml += `
            <a class="pagination__item group" href="javascript:void(0);" onclick="window.changePage(${window.currentPage - 1})" aria-label="Go to page ${window.currentPage - 1}">
                <span class="animated-arrow animated-arrow--reverse"></span>
            </a>
        `;
    }
    
    // 页码部分
    paginationHtml += '<span class="pagination__parts">';
    
    // 页码按钮
    for (let i = 1; i <= window.totalPages; i++) {
        if (
            i === 1 || 
            i === window.totalPages || 
            (i >= window.currentPage - 2 && i <= window.currentPage + 2)
        ) {
            if (i === window.currentPage) {
                paginationHtml += `<span>${i}</span>`;
            } else {
                paginationHtml += `<a href="javascript:void(0);" onclick="window.changePage(${i})" title="">${i}</a>`;
            }
        } else if (
            i === window.currentPage - 3 || 
            i === window.currentPage + 3
        ) {
            paginationHtml += `<span class="more_page">…</span>`;
        }
    }
    
    paginationHtml += '</span>';
    
    // 下一页按钮
    if (window.currentPage === window.totalPages) {
        paginationHtml += `
            <span class="pagination__item pagination__item--disabled">
                <span class="animated-arrow"></span>
            </span>
        `;
    } else {
        paginationHtml += `
            <a class="pagination__item group" href="javascript:void(0);" onclick="window.changePage(${window.currentPage + 1})" aria-label="Go to page ${window.currentPage + 1}">
                <span class="animated-arrow"></span>
            </a>
        `;
    }
    
    paginationHtml += '</nav>';
    
    paginationContainer.innerHTML = paginationHtml;
}

// 确保changePage函数正确定义并且可以被全局访问
window.changePage = function(page) {
    if (page < 1 || page > window.totalPages || page === window.currentPage) return;
    fetchDiamondData(page, filterConditions);
};

// 渲染钻石表格视图
function renderDiamondTable(diamonds) {
    const tableContainer = document.getElementById('diamonds_search_table');
    if (!tableContainer) {
        console.error('Table container not found: #diamonds_search_table');
        return;
    }

   // console.log(`渲染 新的 钻石到表格视图:`, diamonds.length);    

    // 生成表格 HTML
    const tableHtml = diamonds.map(diamond => {
        // 保持现有表格内容
        let ring_url = `/pages/ring-holder-list?diamond_variant=${diamond.sku_id}&handle=${diamond.spu_handle}`;
        let ring_text = 'Add to Ring';
        if(ringVariant && ringHandle){
          ring_url = `/products/${ringHandle}?variant=${ringVariant}&diamond_variant=${diamond.sku_id}&handle=${diamond.spu_handle}`;
          ring_text = 'Selected Diamond';
        }
        return `
            <div class="inner item" data-have="true" data-position="0" data-upc='{"id":"${diamond.id}"}'>
                <a class="td-n2" href="javascript:void(0);">
                    <table width="100%" cellspacing="0" cellpadding="0" border="0" role="presentation" class="table-striped table-hover search-result-table text-33 variant">
                        <tbody>
                            <tr class="search-item" style="height: 50px; border:none">
                                <td class="shape 3" width1="8%" scope="col" style="text-align: left">
                                    <div>
                                       <div style="text-align: left;margin-left: 10px;" class="shape-type">
    <img src="${SHAPE_ICONS[diamond.shape] || diamond.main_image}" width="20" alt="diamond shape" class="mr5 mbm-multiply">
    <span class="shape-type-name">${diamond.shape}</span>
    <span class="shape-type-picture"></span>
</div>  
                                    </div>
                                </td>
                                <td width1="8%" scope="col" class="price">$${Number(diamond.price).toLocaleString()}</td>
                                <td width1="8%" scope="col" class="carat">${Number(diamond.carat).toFixed(2)}</td>
                                <td width1="8%" scope="col" class="cut">${diamond.cut}</td>
                                <td width1="8%" scope="col" class="color">${diamond.color}</td>
                                <td width1="8%" scope="col" class="clarity">${diamond.clarity}</td>
                                <td class="un-bubble-ga ee_data compare_selector ir327-heart js-heart" data-id="${diamond.sku_id}" width="5%" scope="col">
                                    <span><i class="iconfont iconfont-heart fs-14"></i></span>
                                </td>
                                <td width="1%" scope="col"><svg role="presentation" focusable="false" width="7" height="10" class="icon icon-chevron-left reverse-icon" viewBox="0 0 7 10">
        <path d="M6 1 2 5l4 4" fill="none" stroke="currentColor" stroke-width="1"></path>
      </svg></td>
                            </tr>
                        </tbody>
                    </table>
                </a>
                <div class="diamond-details" style="display: none;">
                <div class="detail-container">
                    <div class="diamond-image">
                        <div class="video-placeholder" data-diamond-id="${diamond.sku_id}">
                        ${diamond.video_url ? `
                            <div class="video-container">
                                <video 
                                    src="${diamond.video_url}" 
                                    loop 
                                    muted 
                                    playsinline
                                    preload="metadata"
                                    poster="${diamond.main_image}"
                                    class="diamond-video">
                                </video>
                                <div class="video-play-button">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <path d="M8 5v14l11-7z"/>
                                    </svg>
                                </div>
                            </div>
                        ` : `
                            <img src="${diamond.main_image}" alt="${diamond.shape} Diamond">
                        `}
                        </div>
                    </div>
                        <div class="diamond-info">
                            <div class="diamond-info-left">
                                <h2>${Number(diamond.carat).toFixed(2)} Carat ${diamond.shape} Lab Diamond</h2>
                                <div class="price">$${Number(diamond.price).toLocaleString()}</div>
                                <div class="specs">
                                    <div class="spec-row">
                                        <span class="spec-label">Carat:</span>
                                        <span class="spec-value">${Number(diamond.carat).toFixed(2)}</span>
                                    </div>
                                    <div class="spec-row">
                                        <span class="spec-label">Cut:</span>
                                        <span class="spec-value">${diamond.cut}</span>
                                    </div>
                                    <div class="spec-row">
                                        <span class="spec-label">Color:</span>
                                        <span class="spec-value">${diamond.color}</span>
                                    </div>
                                    <div class="spec-row">
                                        <span class="spec-label">Clarity:</span>
                                        <span class="spec-value">${diamond.clarity}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="diamond-info-right">
                                <div class="select-diamond-dropdown">
                                   
                                        <a href="javascript:void(0);" class="dropdown-item" 
                                        onclick="javascript:window.location.href='${ring_url}'">${ring_text}</a>
                                        <a href="javascript:void(0);" class="dropdown-item add-to-bag" data-id="${diamond.sku_id}">Add to Bag</a>
                                    
                                </div>
                                <a href="/products/${diamond.spu_handle}" class="view-details">View Diamond Details</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }).join('');

    // 更新容器内容
  
    tableContainer.innerHTML = tableHtml;
    
    // 添加事件监听器
    addTableEventListeners();
    initializeVideoControls(); 
}

// 添加表格事件监听器
function addTableEventListeners() {
    // 添加点击事件监听
    document.querySelectorAll('.td-n2').forEach(item => {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            const detailsContainer = this.nextElementSibling;
            const searchItem = this.querySelector('.search-item');
            
            // 检查是否是移动设备
            if (window.innerWidth <= 768) {
                // 关闭其他所有打开的详情
                document.querySelectorAll('.diamond-details').forEach(details => {
                    if (details !== detailsContainer) {
                        details.style.display = 'none';
                        details.previousElementSibling.querySelector('.search-item')?.classList.remove('active');
                    }
                });
            }
            
            if (detailsContainer) {
                if (detailsContainer.style.display === 'none') {
                    detailsContainer.style.display = 'block';
                    searchItem?.classList.add('active');
                    
                    // 在移动端，滚动到展开的项目
                    if (window.innerWidth <= 768) {
                        // 计算需要滚动的位置
                        const rect = this.getBoundingClientRect();
                        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                        const targetPosition = scrollTop + rect.top - 160; // 10px的上边距
                        
                        // 平滑滚动
                        window.scrollTo({
                            top: targetPosition,
                            behavior: 'smooth'
                        });
                    }
                } else {
                    detailsContainer.style.display = 'none';
                    searchItem?.classList.remove('active');
                }
            }
        });
    });

    // 添加收藏按钮点击事件
    document.querySelectorAll('.js-heart').forEach(heart => {
        heart.addEventListener('click', function(e) {
            e.stopPropagation();
            const diamondId = this.getAttribute('data-id');
            toggleFavorite(diamondId);
        });
    });
   
    // 添加购物车点击事件监听
    document.querySelectorAll('.dropdown-item').forEach(item => {
        item.addEventListener('click', async function(e) {
            e.preventDefault();
            const action = this.textContent.trim();
            if (action === 'Add to Bag') {
                const diamondId = this.getAttribute('data-id');
                await addToBag(diamondId);
            }
        });
    });
}

// 渲染钻石网格视图
function renderDiamondGallery(diamonds) {
    const galleryContainer = document.getElementById('diamonds_search_gallery');
    if (!galleryContainer) {
        console.error('Gallery container not found: #diamonds_search_gallery');
        return;
    }

  //  console.log(`渲染 新的 钻石到网格视图:`, diamonds.length);

    // 生成网格 HTML（使用现有的模板代码）
    const galleryHtml = diamonds.map(diamond => {
        // 格式化价格
        const formattedPrice = `$${Number(diamond.price).toLocaleString()}`;
        
        // 格式化4C信息
        const fourCs = `${diamond.cut} · ${diamond.color} · ${diamond.clarity}`;
        
        // 产品名称
        const productName = `${diamond.carat} Carat ${diamond.shape} Lab Diamond`;
        
        // 是否热门
        const isPopular = diamond.is_popular ? `
            <div class="invert ir327-badge" style="background-color: #b4cfcf; color: #183e40">
                <span>In Demand</span>
            </div>` : '';
        let diamond_detail_url = `/products/${diamond.spu_handle}`;
        if(ringVariant && ringHandle){
          diamond_detail_url = `/products/${diamond.spu_handle}?ring_variant=${ringVariant}&ring_handle=${ringHandle}`;
        }
        return `
            <div class="per-product" data-id="${diamond.sku_id}" data-handle="${diamond.spu_handle}">
                <div class="thumbnail ir364-search-results-thumbnail">
                    <div class="thumbnail-item">
                        <div class="thumbnail-imgs">
                            <div class="full-width thumbnail-badging">
                                ${isPopular}
                                <div class="ml-auto d-flex js_compare_selector">
                                    <div class="thumbnail-wishlist">
                                        <div class="js_select_compare niwl ir327-heart js-heart"
                                            style="padding-left: 8px"
                                            data-id="${diamond.sku_id}">
                                            <i class="iconfont iconfont-heart fs-14"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="" style="width: 100%">
                                <a href="${diamond_detail_url}" 
                                   class="pdp_url" 
                                   aria-label="diamond pdp">
                                   <div class="video-placeholder" data-diamond-id="${diamond.sku_id}">
                                   ${diamond.video_url ? `
                                    <div class="video-container">
                                        <video 
                                            src="${diamond.video_url}" 
                                            loop 
                                            muted 
                                            playsinline
                                            preload="metadata"
                                            poster="${diamond.main_image}"
                                            class="diamond-video">
                                        </video>
                                        <div class="video-play-button">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <path d="M8 5v14l11-7z"/>
                                            </svg>
                                        </div>
                                    </div>
                                ` : `
                                    <img src="${diamond.main_image}" alt="${diamond.shape} Diamond">
                                `}
            </div>
                                </a>
                            </div>
                        </div>
                        <div class="text-center thumbnail-caption">
                            <a class="avenir-medium thumbnail-name td-n2" 
                               href="/products/${diamond.spu_handle}">
                                ${productName}
                            </a>
                            <div class="mb5 thumbnail-4Cs">${fourCs}</div>
                            <div class="mb10 thumbnail-price">${formattedPrice}</div>
                            <div class="thumbnail-link">
                                <a href="javascript: void(0);"
                                   class="btn btn-default2 btn-outline-dark display-block text-33 tt-n js-select-diamond-cta"
                                   data-id="${diamond.sku_id}">
                                   Select Diamond
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }).join('');

    galleryContainer.innerHTML = galleryHtml;
    
    // 添加事件监听器
    addGalleryEventListeners();
    initializeVideoControls();
}
function initializeVideoControls() {
    document.querySelectorAll('.video-container').forEach(container => {
        const video = container.querySelector('video');
        const playButton = container.querySelector('.video-play-button');
        
        if (!video || !playButton) return;

        // 移除旧的事件监听器
        const newContainer = container.cloneNode(true);
        container.parentNode.replaceChild(newContainer, container);
        
        const newVideo = newContainer.querySelector('video');
        const newPlayButton = newContainer.querySelector('.video-play-button');
        
        // 添加点击事件
        newContainer.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            if (newVideo.paused) {
                newVideo.play()
                    .then(() => {
                        newPlayButton.style.display = 'none';
                    })
                    .catch(error => {
                        console.error('视频播放失败:', error);
                    });
            } else {
                newVideo.pause();
                newPlayButton.style.display = 'flex';
            }
        });

        // 视频事件监听
        newVideo.addEventListener('ended', () => {
            newVideo.currentTime = 0;
            newPlayButton.style.display = 'flex';
        });

        newVideo.addEventListener('pause', () => {
            newPlayButton.style.display = 'flex';
        });

        newVideo.addEventListener('play', () => {
            newPlayButton.style.display = 'none';
        });

        // 设置初始状态
        newPlayButton.style.display = 'flex';
        newVideo.currentTime = 0;
    });
}

// 添加网格视图事件监听器
function addGalleryEventListeners() {
    // 添加收藏按钮点击事件
    document.querySelectorAll('.js-heart').forEach(heart => {
        heart.addEventListener('click', function(e) {
            e.stopPropagation();
            const diamondId = this.getAttribute('data-id');
            toggleFavorite(diamondId);
        });
    });
    
    // 添加选择钻石按钮点击事件
   document.querySelectorAll('.js-select-diamond-cta').forEach(button => {
    button.addEventListener('click', function(e) {
        e.preventDefault();
        
        // 检查是否已经存在下拉菜单
        const existingDropdown = this.parentNode.querySelector('.diamond-selection-dropdown');
        if (existingDropdown) {
            // 如果已存在下拉菜单，则移除它并返回
            existingDropdown.remove();
            return;
        }

        const diamondId = this.getAttribute('data-id');
        const productElement = this.closest('.per-product');
        const spuHandle = productElement ? productElement.getAttribute('data-handle') : '';
        
        // 创建下拉菜单
        const dropdown = document.createElement('div');
        dropdown.className = 'diamond-selection-dropdown';
        
        // 保持现有表格内容
        let ring_url = `/pages/ring-holder-list?diamond_variant=${diamondId}&handle=${spuHandle}`;
        let ring_text = 'Add to Ring';
        if(ringVariant && ringHandle){
            ring_url = `/products/${ringHandle}?variant=${ringVariant}&diamond_variant=${diamondId}&handle=${spuHandle}`;
            ring_text = 'Selected Diamond';
        }
        
        dropdown.innerHTML = `
            <div class="dropdown-options">
                <a href="javascript:void(0);" class="dropdown-item" 
                   onclick="javascript:window.location.href='${ring_url}'">
                   ${ring_text}
                </a>
                <a href="javascript:void(0);" class="dropdown-item add-to-bag" data-id="${diamondId}">
                   Add to Bag
                </a>
            </div>
        `;
        
        // 移除任何其他已存在的下拉菜单
        document.querySelectorAll('.diamond-selection-dropdown').forEach(el => el.remove());
        
        // 添加新的下拉菜单
        this.parentNode.appendChild(dropdown);
        
        // 添加点击事件到"添加到购物袋"选项
        dropdown.querySelector('.add-to-bag').addEventListener('click', function() {
            const id = this.getAttribute('data-id');
            addToBag(id);
        });
        
        // 点击其他地方关闭下拉菜单
        document.addEventListener('click', function closeDropdown(e) {
            if (!e.target.closest('.diamond-selection-dropdown') && 
                !e.target.closest('.js-select-diamond-cta')) {
                dropdown.remove();
                document.removeEventListener('click', closeDropdown);
            }
        });
    });
});
}

// 更新总数显示
function updateTotalCount(count) {
    const totalResult = document.getElementById('totalResult');
    if (totalResult) {
        totalResult.textContent = count.toLocaleString();
    }
}

// 收藏功能
function toggleFavorite(diamondId) {
    // 这里实现收藏逻辑
    console.log('Toggle favorite for diamond:', diamondId);
}

// 添加到购物车函数
async function addToBag(diamondId) {
    try {
        const formData = {
            'items': [{
                'id': Number(diamondId),
                'quantity': 1
            }]
        };

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(formData)
        });

        if (response.ok) {
            // 成功添加后直接跳转到购物车页面
            window.location.href = '/cart';
        } else {
            const result = await response.json();
            throw new Error(result.description || 'Failed to add to cart');
        }
    } catch (error) {
        console.error('Error adding to cart:', error);
        showMessage(error.message || 'Failed to add to cart. Please try again.', 'error');
    }
}

// 更新购物车计数
async function updateCartCount() {
    try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await response.json();
        // 假设页面上有一个购物车计数器元素
        const cartCounter = document.querySelector('.cart-count');
        if (cartCounter) {
            cartCounter.textContent = cart.item_count;
        }
    } catch (error) {
        console.error('Error updating cart count:', error);
    }
}

// 显示消息提示
function showMessage(message, type = 'success') {
    const messageDiv = document.createElement('div');
    messageDiv.className = `message-toast ${type}`;
    messageDiv.textContent = message;
    document.body.appendChild(messageDiv);

    // 3秒后自动消失
    setTimeout(() => {
        messageDiv.remove();
    }, 3000);
}

// 添加消息提示的样式
const additionalStyles = `
    .message-toast {
        position: fixed;
        top: 20px;
        right: 20px;
        padding: 15px 25px;
        border-radius: 4px;
        z-index: 1000;
        animation: slideIn 0.3s ease-out;
    }

    .message-toast.success {
        background-color: #4CAF50;
        color: white;
    }

    .message-toast.error {
        background-color: #f44336;
        color: white;
    }

    @keyframes slideIn {
        from {
            transform: translateX(100%);
            opacity: 0;
        }
        to {
            transform: translateX(0);
            opacity: 1;
        }
    }
`;

// 更新样式


// 添加样式
const style = document.createElement('style');
style.textContent = `
    .diamond-selection-dropdown {
        position: absolute;
        background: white;
        border: 1px solid #eee;
        border-radius: 4px;
        box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        z-index: 10;
        width: 100%;
        margin-top: 5px;
    }
    
    .dropdown-options {
        display: flex;
        flex-direction: column;
    }
    
    .dropdown-item {
        padding: 10px 15px;
        text-decoration: none;
        color: #333;
        transition: background 0.3s ease;
        display:block;
    }
    
    .dropdown-item:hover {
        background: #f5f5f5;
    }
    
    .diamond-details {
        padding: 16px;
        background: #fff;
        border-top: 1px solid #eee;
    }
    
    .detail-container {
        display: flex;
        gap: 60px;
        max-width: 1200px;
        margin: 0 auto;
    }
    
    .diamond-image {
        width: 220px;
        background: #f5f5f5;
        height: 220px;
        margin: 0 auto;
    }
    
    .video-placeholder {
        background: #f5f5f5;
        width: 220px;
        height: 220px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .video-placeholder img {
        max-width: 100%;
        height: auto;
        margin: 0 auto;
    }
    
    .diamond-info {
        flex: 1;
        padding: 20px 0;
        display: flex;
        gap: 16px;
    }
    
    .diamond-info-left {
        flex: 1 1 0;
    }
    
    .diamond-info-right {
        flex: 0 0 220px;
    }
    
    .diamond-info h2 {
        font-size: 16px;
        margin: 0;
        font-weight: normal;
        color: #333;
    }
    
    .price {
        font-size: 18px;
        margin-bottom: 10px;
        color: #333;
    }
    
    .specs {
        border-top: 1px solid #eee;
        margin-bottom: 30px;
        padding-top: 0;
    }
    
    .spec-row {
        display: flex;
        padding: 5px 0;
        border-bottom: 1px solid #eee;
    }
    
    .spec-label {
        width: 100px;
        color: #333;
    }
    
    .spec-value {
        color: #333;
    }
    
    .select-diamond-dropdown {
        position: relative;
        margin-bottom: 20px;
    }
    
    .select-diamond {
        width: 100%;
        padding: 15px;
        background: #333;
        color: white;
        border: none;
        font-size: 16px;
        cursor: pointer;
        text-align: center;
        transition: background-color 0.3s;
    }
    
    .select-diamond:hover {
        background: #444;
    }
    
    .dropdown-content {
        display: none;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        box-shadow: 0 2px 5px rgba(0,0,0,0.1);
        z-index: 1;
    }
    
    .select-diamond-dropdown:hover .dropdown-content {
        display: block;
    }
    
    .view-details {
        display: block;
        text-align: center;
        color: #333;
        text-decoration: underline;
        margin-top: 20px;
    }
    
    .search-item.active {
        background-color: #f5f5f5;
    }
    
    /* 排序相关样式 */
    .sort-option.active {
        font-weight: bold;
        color: #2F4F4F;
    }
    
   [class^="icons-"], [class*=" icons-"] {
    background-image: url(https://cdn.shopify.com/s/files/1/0872/0934/5300/files/spirit-icons-6-cache2.png?v=1744155004);
    background-position: 0 0;
    background-repeat: no-repeat;
    display: inline-block;
    line-height: 16px;
}
.icons-chevron-up {
    width: 9px;
    height: 5px;
    background-position: -82px -46px
}

.icons-chevron-down {
    width: 9px;
    height: 5px;
    background-position: -96px -46px
}
         /* 加载更多相关样式 */
    .load-more-indicator {
        height: 50px;
        margin: 20px 0;
        text-align: center;
    }
    
    .diamond-loading {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(255, 255, 255, 0.9);
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        z-index: 1000;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    
    .diamond-loading.hidden {
        display: none;
    }
    
    .loading-spinner {
        border: 4px solid #f3f3f3;
        border-top: 4px solid #2F4F4F;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        animation: spin 1s linear infinite;
        margin-bottom: 10px;
    }
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    @media (max-width: 768px){
      #diamonds_search_table tr.search-item td {
        width:15%;
      }
      #diamonds_search_table tr.search-item td.shape {
        width:30%;
      }
      #diamonds_search_table .diamond-details .detail-container {
        gap:5px;
      }
      #diamonds_search_table .diamond-details .detail-container .diamond-image {
        width:50%;
      }
      #diamonds_search_table .diamond-details .detail-container .video-placeholder {
        height:100%;
      }
      #diamonds_search_table .diamond-details .detail-container .diamond-info {
            flex: 1;
        padding: 0px 0;
        display: flex;
        gap: 10px;
        flex-direction: column;
        justify-content: flex-start;
      }
      #diamonds_search_table .diamond-details .detail-container .diamond-info h2 {
        font-size:12px;
      }
      #diamonds_search_table .diamond-details .detail-container .diamond-info .price {
        font-size:15px;
      }
      #diamonds_search_table .diamond-details .detail-container .diamond-info .specs {
        margin-bottom:unset;
      }
      #diamonds_search_table .diamond-details .detail-container .diamond-info .specs .spec-row {
        display: flex;
        padding: 2px 0;
        border-bottom: 1px solid #eee;
        font-size: 12px;
      }
      #diamonds_search_table .diamond-details .detail-container .diamond-info .diamond-info-right {
        flex: 0 0 10px;
      }
      #diamonds_search_table .diamond-details .detail-container .diamond-info .select-diamond-dropdown {
        margin-bottom: 5px;
      }
      #diamonds_search_table .diamond-details .detail-container .diamond-info  .view-details {
        margin-top: 0px;
      }
      #diamonds_search_table .diamond-details .detail-container .diamond-image {
        background:unset;
      }
      #diamonds_search_table .diamond-details .detail-container .video-placeholder {
        background: unset;
        width: 100%;
        height: auto;
      }
      #diamonds_search_table .diamond-details .detail-container .select-diamond {
        padding:5px;
        font-size:13px;
      }
    }
`;
document.head.appendChild(style);
style.textContent += additionalStyles;

// 定义筛选条件对象
let filterConditions = {
    shapes: [],
    min_price: 10,
    max_price: 3000,
    min_carat: 0.25,
    max_carat: 10,
    cuts: [],
    colors: [],
    clarities: []
};

// 定义等级数组
const GRADES = {
    cut: ['Fair', 'Good', 'Excellent', 'Ideal', 'Super Ideal'],
    color: ['J', 'I', 'H', 'G', 'F', 'E', 'D'],
    clarity: ['SI2', 'SI1', 'VS2', 'VS1', 'VVS2', 'VVS1', 'IF', 'FL']
};

// 防抖函数
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// 初始化所有筛选器
function initializeFilters() {
    initializeRangeSliders();
    initializeGradeSliders();
    initializeShapeFilter();
}

// 初始化范围滑块
function initializeRangeSliders() {
    // 临时存储值，只有点击搜索时才更新到 filterConditions
    let tempValues = {
        carat: {
            min: 0.25,
            max: 10
        },
        price: {
            min: 310,
            max: 10000
        }
    };

    // 克拉范围滑块
    const caratContainer = document.getElementById('carat_container');
    if (caratContainer) {
        const minRange = document.getElementById('carat_min');
        const maxRange = document.getElementById('carat_max');
        const minValue = document.getElementById('carat_min_value');
        const maxValue = document.getElementById('carat_max_value');

        minRange.addEventListener('input', function() {
            tempValues.carat.min = Number(this.value);
            minValue.textContent = Number(this.value).toFixed(2);
            updateSliderTrack('carat');
        });

        maxRange.addEventListener('input', function() {
            tempValues.carat.max = Number(this.value);
            maxValue.textContent = Number(this.value).toFixed(2);
            updateSliderTrack('carat');
        });

        // 添加搜索按钮事件
        const searchBtn = document.getElementById('carat_search');
        if (searchBtn) {
            searchBtn.addEventListener('click', function() {
                filterConditions.min_carat = tempValues.carat.min;
                filterConditions.max_carat = tempValues.carat.max;
                debouncedSubmitFilters();
            });
        }
    }

    // 价格范围滑块
    const priceContainer = document.getElementById('price_container');
    if (priceContainer) {
        const minRange = document.getElementById('price_min');
        const maxRange = document.getElementById('price_max');
        const minValue = document.getElementById('price_min_value');
        const maxValue = document.getElementById('price_max_value');

        minRange.addEventListener('input', function() {
            tempValues.price.min = Number(this.value);
            minValue.textContent = `$${Number(this.value).toLocaleString()}`;
            updateSliderTrack('price');
        });

        maxRange.addEventListener('input', function() {
            tempValues.price.max = Number(this.value);
            maxValue.textContent = `$${Number(this.value).toLocaleString()}`;
            updateSliderTrack('price');
        });

        // 添加搜索按钮事件
        const searchBtn = document.getElementById('price_search');
        if (searchBtn) {
            searchBtn.addEventListener('click', function() {
                filterConditions.min_price = tempValues.price.min;
                filterConditions.max_price = tempValues.price.max;
                debouncedSubmitFilters();
            });
        }
    }
}

// 更新滑块轨道
function updateSliderTrack(type) {
    const track = document.getElementById(`${type}_track`);
    const minRange = document.getElementById(`${type}_min`);
    const maxRange = document.getElementById(`${type}_max`);
    
    if (!minRange || !maxRange || !track) {
        console.error(`Missing ${type} slider elements`);
        return;
    }

    const percent1 = ((minRange.value - minRange.min) / (minRange.max - minRange.min)) * 100;
    const percent2 = ((maxRange.value - minRange.min) / (minRange.max - minRange.min)) * 100;
    
    track.style.background = `linear-gradient(to right, #ddd ${percent1}%, #2F4F4F ${percent1}%, #2F4F4F ${percent2}%, #ddd ${percent2}%)`;
}

// 初始化所有等级滑块
function initializeGradeSliders() {
    initializeGradeSlider('cut');
    initializeGradeSlider('color');
    initializeGradeSlider('clarity');
}

function initializeGradeSlider(type) {
    const slider = document.getElementById(`${type}Slider`);
    const grades = GRADES[type];
    const gradesContainer = document.getElementById(`${type}Grades`);
    
    // 初始化等级标签
    gradesContainer.innerHTML = grades.map((grade, index) => 
        `<span data-index="${index}" data-value="${grade}">${grade}</span>`
    ).join('');

    // 存储选中的值
    let selectedValues = [];
    
    // 滑块相关的代码
    const range = slider.querySelector('.range');
    const thumbLeft = slider.querySelector('.thumb.left');
    const thumbRight = slider.querySelector('.thumb.right');
    
    // 添加滑块拖动事件
    let isDragging = false;
    let currentThumb = null;
    
    // 鼠标/触摸开始事件
    function onStart(e) {
        isDragging = true;
        currentThumb = e.target;
        // 阻止页面滚动
        e.preventDefault();
        
        // 添加移动和结束事件监听
        if (e.type === 'mousedown') {
            document.addEventListener('mousemove', onMove);
            document.addEventListener('mouseup', onEnd);
        } else if (e.type === 'touchstart') {
            document.addEventListener('touchmove', onMove, { passive: false });
            document.addEventListener('touchend', onEnd);
        }
    }
    
    // 鼠标/触摸移动事件
    function onMove(e) {
        if (!isDragging) return;
        
        // 阻止页面滚动
        e.preventDefault();
        
        const sliderRect = slider.getBoundingClientRect();
        const clientX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
        const percent = Math.min(Math.max(0, ((clientX - sliderRect.left) / sliderRect.width) * 100), 100);
        
        // 确保左滑块不会超过右滑块，右滑块不会超过左滑块
        if (currentThumb === thumbLeft) {
            const rightPos = parseFloat(thumbRight.style.left) || 100;
            if (percent < rightPos) {
                thumbLeft.style.left = `${percent}%`;
            }
        } else if (currentThumb === thumbRight) {
            const leftPos = parseFloat(thumbLeft.style.left) || 0;
            if (percent > leftPos) {
                thumbRight.style.left = `${percent}%`;
            }
        }
        
        updateRange();
    }
    
    // 鼠标/触摸结束事件
    function onEnd() {
        isDragging = false;
        currentThumb = null;
        
        // 移除事件监听
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onEnd);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onEnd);
    }
    
    // 更新滑块范围和选中状态
    function updateRange() {
        const left = parseFloat(thumbLeft.style.left) || 0;
        const right = parseFloat(thumbRight.style.left) || 100;
        
        // 更新范围条的位置和宽度
        range.style.left = `${left}%`;
        range.style.width = `${right - left}%`;
        
        // 计算选中的等级
        const spans = gradesContainer.querySelectorAll('span');
        selectedValues = [];
        
        spans.forEach((span, index) => {
            const position = (index / (grades.length - 1)) * 100;
            const isActive = position >= left && position <= right;
            span.classList.toggle('active', isActive);
            
            if (isActive) {
                selectedValues.push(span.getAttribute('data-value'));
            }
        });
        
        // 更新 filterConditions
        if (type === 'clarity') {
            filterConditions.clarities = [...selectedValues];
        } else {
            filterConditions[`${type}s`] = [...selectedValues];
        }
        
      //  console.log(`Selected ${type}s:`, selectedValues);
    }
    
    // 添加鼠标和触摸事件监听
    thumbLeft.addEventListener('mousedown', onStart);
    thumbLeft.addEventListener('touchstart', onStart, { passive: false });
    thumbRight.addEventListener('mousedown', onStart);
    thumbRight.addEventListener('touchstart', onStart, { passive: false });
    
    // 点击等级标签事件
    gradesContainer.querySelectorAll('span').forEach(span => {
        span.addEventListener('click', function() {
            const index = parseInt(this.getAttribute('data-index'));
            const position = (index / (grades.length - 1)) * 100;
            
            // 如果点击的是已选中区域内的标签，则取消选中
            const left = parseFloat(thumbLeft.style.left) || 0;
            const right = parseFloat(thumbRight.style.left) || 100;
            
            if (position >= left && position <= right) {
                // 如果是边界值，移动对应的滑块
                if (position === left) {
                    thumbLeft.style.left = `${Math.min(position + (100 / (grades.length - 1)), right)}%`;
                } else if (position === right) {
                    thumbRight.style.left = `${Math.max(position - (100 / (grades.length - 1)), left)}%`;
                }
            } else {
                // 如果点击的是未选中区域，扩展滑块范围
                if (position < left) {
                    thumbLeft.style.left = `${position}%`;
                } else {
                    thumbRight.style.left = `${position}%`;
                }
            }
            
            updateRange();
        });
        
        // 添加触摸事件支持
        span.addEventListener('touchstart', function(e) {
            e.preventDefault();
            this.click();
        }, { passive: false });
    });
    
    // 添加搜索按钮点击事件
    const searchBtn = document.getElementById(`${type}_search`);
    if (searchBtn) {
        searchBtn.addEventListener('click', function() {
            debouncedSubmitFilters();
        });
    }
    
    // 初始化滑块位置
    thumbLeft.style.left = '0%';
    thumbRight.style.left = '100%';
    updateRange();
}




// 初始化形状筛选
function initializeShapeFilter() {
    const shapeItems = document.querySelectorAll('[data-shape]');
    
    shapeItems.forEach(item => {
        const checkbox = item.querySelector('input[type="checkbox"]');
        const link = item.querySelector('.custom-control-a');
        
        if (link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                
                // 切换选中状态
                const isChecked = checkbox.checked;
                checkbox.checked = !isChecked;
                
                // 更新视觉状态
                item.classList.toggle('active', !isChecked);
                
                // 更新筛选条件
                const shape = item.getAttribute('data-shape');
                if (!isChecked) {
                    // 添加形状
                    if (!filterConditions.shapes.includes(shape)) {
                        filterConditions.shapes.push(shape);
                    }
                } else {
                    // 移除形状
                    const index = filterConditions.shapes.indexOf(shape);
                    if (index > -1) {
                        filterConditions.shapes.splice(index, 1);
                    }
                }
                
                // 提交筛选
                debouncedSubmitFilters();
            });
        }
    });
}


const debouncedSubmitFilters = debounce(async function() {
    try {
        window.isLoading = true; // 设置加载状态，防止并发请求
        showLoadingState();
        
        // 把过滤条件作为参数传递给 fetchDiamondData
        await fetchDiamondData(1, filterConditions, false);
        
    } catch (error) {
        console.error('Error applying filters:', error);
        showError(error.message);
    } finally {
        hideLoadingState();
        window.isLoading = false;
    }
}, 500);

// 显示加载中状态
function showLoadingState() {
    const loadingElement = document.getElementById('diamond_loading');
    if (loadingElement) {
        loadingElement.classList.remove('hidden');
    } else {
        // 如果页面中没有加载元素，创建一个
        const loadingDiv = document.createElement('div');
        loadingDiv.id = 'diamond_loading';
        loadingDiv.className = 'diamond-loading';
        loadingDiv.innerHTML = '<div class="loading-spinner"></div><p>loading...</p>';
        document.body.appendChild(loadingDiv);
    }
}

// 隐藏加载中状态
function hideLoadingState() {
    const loadingElement = document.getElementById('diamond_loading');
    if (loadingElement) {
        loadingElement.classList.add('hidden');
    }
}

// 显示无结果提示
function showNoResults() {
    // 更新表格视图
    const tableContainer = document.getElementById('diamonds_search_table');
    if (tableContainer) {
        console.log('Showing no results message in table view');
        tableContainer.innerHTML = `
            <div class="no-data">
                <p>No diamonds found matching your criteria</p>
                <p class="suggestion">Try adjusting your filters to see more results</p>
            </div>
        `;
    }
    
    // 更新网格视图
    const galleryContainer = document.getElementById('diamonds_search_gallery');
    if (galleryContainer) {
        console.log('Showing no results message in gallery view');
        galleryContainer.innerHTML = `
            <div class="no-data">
                <p>No diamonds found matching your criteria</p>
                <p class="suggestion">Try adjusting your filters to see more results</p>
            </div>
        `;
    }
    
    updateTotalCount(0);
}

// 显示错误信息
function showError(message) {
    // 更新表格视图
    const tableContainer = document.getElementById('diamonds_search_table');
    if (tableContainer) {
        console.log('Showing error message in table view:', message);
        tableContainer.innerHTML = `
            <div class="error-message">
                <p>Error: ${message}</p>
            </div>
        `;
    }
    
    // 更新网格视图
    const galleryContainer = document.getElementById('diamonds_search_gallery');
    if (galleryContainer) {
        console.log('Showing error message in gallery view:', message);
        galleryContainer.innerHTML = `
            <div class="error-message">
                <p>Error: ${message}</p>
            </div>
        `;
    }
}

// 重置所有筛选条件
function resetAllFilters() {
    filterConditions = {
        shapes: [],
        min_price: 10,
        max_price: 3000,
        min_carat: 0.25,
        max_carat: 10,
        cuts: [],
        colors: [],
        clarities: []
    };

    // 重置形状选择
    document.querySelectorAll('[data-shape]').forEach(item => {
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (checkbox) {
            checkbox.checked = false;
        }
        item.classList.remove('active');
    });

    // 重置克拉滑块
    document.getElementById('carat_min').value = 0.25;
    document.getElementById('carat_max').value = 10;
    document.getElementById('carat_min_value').textContent = '0.25';
    document.getElementById('carat_max_value').textContent = '10';
    updateSliderTrack('carat');

    // 重置价格滑块
    document.getElementById('price_min').value = 310;
    document.getElementById('price_max').value = 10000;
    document.getElementById('price_min_value').textContent = '$310';
    document.getElementById('price_max_value').textContent = '$10,000';
    updateSliderTrack('price');

    // 重置等级选择
    ['cutGrades', 'colorGrades', 'clarityGrades'].forEach(id => {
        const container = document.getElementById(id);
        if (container) {
            container.querySelectorAll('span').forEach(span => {
                span.classList.remove('active');
            });
        }
    });
    
    // 获取初始数据
    fetchDiamondData();
}

// 初始化排序下拉菜单交互
function initializeSortDropdown() {
    // 获取排序下拉菜单元素
    const sortDropdown = document.getElementById('js_dropdown_sort_by');
    if (!sortDropdown) {
        console.error('Sort dropdown not found: #js_dropdown_sort_by');
        return;
    }
    
    // 获取下拉菜单切换按钮和菜单内容
    const dropdownToggle = sortDropdown.querySelector('.dropdown-toggle');
    const dropdownMenu = sortDropdown.querySelector('.dropdown-menu');
    
    if (!dropdownToggle || !dropdownMenu) {
        console.error('Dropdown toggle or menu not found');
        return;
    }
    
    // 点击切换按钮显示/隐藏下拉菜单
    dropdownToggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // 切换下拉菜单的显示状态
        const isVisible = dropdownMenu.classList.contains('show');
        if (isVisible) {
            dropdownMenu.classList.remove('show');
        } else {
            dropdownMenu.classList.add('show');
        }
        
        // 更新aria-expanded属性
        this.setAttribute('aria-expanded', !isVisible);
    });
    
    // 点击页面其他地方时关闭下拉菜单
    document.addEventListener('click', function(e) {
        if (!sortDropdown.contains(e.target)) {
            dropdownMenu.classList.remove('show');
            dropdownToggle.setAttribute('aria-expanded', 'false');
        }
    });
    
    // 点击排序选项时关闭下拉菜单并更新排序
    const sortOptions = dropdownMenu.querySelectorAll('.sort-option');
    sortOptions.forEach(option => {
        option.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // 移除其他选项的active类
            sortOptions.forEach(opt => opt.classList.remove('active'));
            // 添加当前选项的active类
            this.classList.add('active');
            
            // 更新排序文本
            const sortText = this.textContent.trim();
            document.querySelector('.js-sort_result').textContent = sortText;
            
            // 关闭下拉菜单
            dropdownMenu.classList.remove('show');
            dropdownToggle.setAttribute('aria-expanded', 'false');
            
            // 获取排序参数
            const orderBy = this.getAttribute('data-order-by');
            const orderMethod = this.getAttribute('data-order-method');
            
            // 更新排序图标
            updateSortIcons(orderBy, orderMethod);
            
            // 重新获取数据，使用正确的参数名称
            fetchDiamondData(1, {
                ...filterConditions, 
                order_by: orderBy, 
                order_method: orderMethod
            });
        });
    });
}

// 更新排序图标
function updateSortIcons(orderBy, orderMethod) {
    // 重置所有图标
    document.querySelectorAll('[id^="order_by_"]').forEach(icon => {
        icon.className = 'icons-chevron-down';
    });
    
    // 设置当前排序的图标
    const icon = document.getElementById(`order_by_${orderBy}`);
    if (icon) {
        icon.className = orderMethod === 'asc' ? 'icons-chevron-up' : 'icons-chevron-down';
    }
}

// 初始化表头排序
function initializeTableHeaderSort() {
    const headerLinks = document.querySelectorAll('#js_sort_by_header_table a[data-order-by]');
    
    headerLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const orderBy = this.getAttribute('data-order-by');
            const currentMethod = this.getAttribute('data-order-method');
            const newMethod = currentMethod === 'asc' ? 'desc' : 'asc';
            
            // 更新所有表头的排序方法
            headerLinks.forEach(headerLink => {
                if (headerLink !== this) {
                    headerLink.setAttribute('data-order-method', 'desc');
                }
            });
            
            // 更新当前表头的排序方法
            this.setAttribute('data-order-method', newMethod);
            
            // 更新排序图标
            updateSortIcons(orderBy, newMethod);
            
            // 重新获取数据，使用正确的参数名称
            fetchDiamondData(1, {
                ...filterConditions, 
                order_by: orderBy, 
                order_method: newMethod
            });
        });
    });
}


// 添加一个新的函数来处理表头固定
function initializeFixedHeader() {
    const searchResultHeader = document.getElementById('search_result_header_table');
    let headerOriginalTop = "150px";
    let isHeaderFixed = false;

    // 获取初始位置
    if (searchResultHeader) {
        headerOriginalTop = searchResultHeader.offsetTop;
    }

    // 添加滚动事件监听
    window.addEventListener('scroll', () => {
        if (!searchResultHeader) return;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // 只在移动端处理
        if (window.innerWidth <= 768) {
            if (scrollTop > headerOriginalTop && !isHeaderFixed) {
                // 添加固定样式
                searchResultHeader.style.position = 'fixed';
                searchResultHeader.style.top = '122px';
                searchResultHeader.style.left = '0';
                searchResultHeader.style.right = '0';
                searchResultHeader.style.zIndex = '100';
                searchResultHeader.style.background = '#fff';
                searchResultHeader.style.borderBottom = '1px solid #eee';
                // 添加一个占位元素，防止内容跳动
                const placeholder = document.createElement('div');
                placeholder.style.height = `${searchResultHeader.offsetHeight}px`;
                placeholder.id = 'header-placeholder';
                searchResultHeader.parentNode.insertBefore(placeholder, searchResultHeader);
                isHeaderFixed = true;
            } else if (scrollTop <= headerOriginalTop && isHeaderFixed) {
                // 移除固定样式
                searchResultHeader.style.position = '';
                searchResultHeader.style.top = '';
                searchResultHeader.style.left = '';
                searchResultHeader.style.right = '';
                searchResultHeader.style.zIndex = '';
                searchResultHeader.style.background = '';
                searchResultHeader.style.borderBottom = '';
                // 移除占位元素
                const placeholder = document.getElementById('header-placeholder');
                if (placeholder) {
                    placeholder.remove();
                }
                isHeaderFixed = false;
            }
        }
    });
}


document.addEventListener('DOMContentLoaded', () => {
    // 初始化全局变量
    window.currentPage = 1;
    window.totalPages = 1;
    window.isLoading = false;
    initializeFixedHeader(); 
    // 添加下拉菜单样式
    const dropdownStyle = document.createElement('style');
    dropdownStyle.textContent = `
        .dropdown-menu.show {
            display: block;
        }
    `;
    document.head.appendChild(dropdownStyle);
    
    // 添加视图切换事件监听
    const viewSwitchers = document.querySelectorAll('.ir364-filter-type');
    const tableView = document.getElementById('js_table_search_results');
    const galleryView = document.getElementById('js_gallery_search_results');
        const search_result= document.getElementById('search_result_header_table');
    viewSwitchers.forEach(switcher => {
        switcher.addEventListener('click', function() {
            // 移除所有切换器的active类
            viewSwitchers.forEach(s => s.classList.remove('active'));
            // 添加当前切换器的active类
            this.classList.add('active');
            
            // 获取目标视图类型
            const targetView = this.getAttribute('data-list-type');
            
            // 切换视图显示
            if (targetView === 'js_table_search_results') {
                tableView.classList.remove('hidden');
                galleryView.classList.add('hidden');
              search_result.classList.remove('hidden')
            } else {
                tableView.classList.add('hidden');
                galleryView.classList.remove('hidden');
              search_result.classList.add('hidden')
            }
        });
    });
    
    initializeFilters();
    initializeVideoControls(); 
    // 添加重置按钮事件监听
    const resetButton = document.getElementById('reset_all_filters');
    if (resetButton) {
        resetButton.addEventListener('click', resetAllFilters);
    }

    // 初始化排序下拉菜单
    initializeSortDropdown();
    
    // 初始化表头排序
    initializeTableHeaderSort();
    
    // 获取初始数据
    fetchDiamondData();
});

